const numberFormatter = new Intl.NumberFormat("zh-CN");
const compactFormatter = new Intl.NumberFormat("zh-CN", {
  notation: "compact",
  maximumFractionDigits: 1,
});
const dateFormatter = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

export function formatExactInteger(value: string | null): string {
  if (value === null) return "—";
  return numberFormatter.format(BigInt(value));
}

export function formatCompact(value: number): string {
  return compactFormatter.format(value);
}

export function formatDate(value: number | string | null): string {
  if (value === null) return "未知";
  const date = typeof value === "number" ? new Date(value) : new Date(value);
  return Number.isNaN(date.getTime()) ? "未知" : dateFormatter.format(date);
}

export function formatRelativeTimestamp(value: number | null): string {
  if (value === null) return "尚未刷新";
  return `更新于 ${dateFormatter.format(new Date(value))}`;
}

export function formatBytes(value: number): string {
  if (value < 1024) return `${formatNumber(value)} B`;
  const units = ["KiB", "MiB", "GiB", "TiB"];
  let amount = value / 1024;
  let index = 0;
  while (amount >= 1024 && index < units.length - 1) {
    amount /= 1024;
    index += 1;
  }
  return `${amount.toFixed(amount >= 10 ? 1 : 2)} ${units[index]}`;
}

export function formatDuration(value: number | null): string {
  if (value === null) return "—";
  if (value < 1000) return `${formatNumber(value)} ms`;
  return `${(value / 1000).toFixed(value < 10_000 ? 2 : 1)} s`;
}

export function formatQuotaDuration(seconds: number): string {
  if (seconds % 86_400 === 0) return `${formatNumber(seconds / 86_400)} 天`;
  if (seconds % 3_600 === 0) return `${formatNumber(seconds / 3_600)} 小时`;
  if (seconds % 60 === 0) return `${formatNumber(seconds / 60)} 分钟`;
  return `${formatNumber(seconds)} 秒`;
}

export function truncateMiddle(value: string, head = 12, tail = 8): string {
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}

export function formatPercent(value: number): string {
  return `${Math.max(0, Math.min(100, value)).toFixed(value < 10 ? 1 : 0)}%`;
}
